export default "__VITE_ASSET__06501722__"